/**
 * Filkhedma API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { GuaranteeQtyServiceVisit } from './guaranteeQtyServiceVisit';


export interface ForceUpdateOrderService { 
    /**
     * Service ID
     */
    serviceId?: string;
    /**
     * Service Type
     */
    type?: ForceUpdateOrderService.TypeEnum;
    /**
     * Service Remaining Quantity
     */
    qty?: number;
    qtyVisitIds?: Array<GuaranteeQtyServiceVisit>;
}
export namespace ForceUpdateOrderService {
    export type TypeEnum = 'guarantee';
    export const TypeEnum = {
        Guarantee: 'guarantee' as TypeEnum
    };
}
